module.exports = "/_next/static/images/join-xtimes-airdrop-pt-br-b2449f021b72e996c91a619161e22200.png";